/* globals axios */
import Vue from 'vue';

Vue.component('anchor-link-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            targetEl: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        anchorButtonClick(event) {
            event.preventDefault();
            const target = event.target.getAttribute('href');
            console.log(target);

            this.targetEl = document.querySelector(target);
            console.log('targetEl', this.targetEl);

            this.targetEl.scrollIntoView({ behavior: 'smooth' });
        },
    },
});
